import React, { useState, useEffect } from 'react';
import {
  LoginFormWrapper,
  FormGroup,
  Label,
  Input,
  ForgotPassword,
  SubmitButton,
  AlertError,
  CloseButton,
} from './styles';

interface LoginFormProps {
  onSubmit: (email: string, password: string, empresa: string) => void;
  onForgotPassword: (email: string, empresa: string) => void;
  error?: string | null;
  onClearError?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  onSubmit,
  onForgotPassword,
  error = null,
  onClearError,
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [empresa, setEmpresa] = useState('');

  // Recuperar empresa do localStorage
  useEffect(() => {
    const savedEmpresa = localStorage.getItem('loginEmpresa');
    if (savedEmpresa) {
      setEmpresa(savedEmpresa);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && password && empresa) {
      localStorage.setItem('loginEmpresa', empresa);
      onSubmit(email, password, empresa);
    }
  };

  const handleForgotPassword = () => {
    if (email && empresa) {
      onForgotPassword(email, empresa);
    } else {
      alert(
        'Por favor, preencha os campos de e-mail e empresa para redefinir sua senha.'
      );
    }
  };

  return (
    <LoginFormWrapper>
      <form onSubmit={handleSubmit} id="loginForm">
        {error && (
          <AlertError>
            {error}
            <CloseButton type="button" onClick={onClearError}>
              ×
            </CloseButton>
          </AlertError>
        )}
        <FormGroup>
          <Label htmlFor="empresa">Empresa:</Label>
          <Input
            type="text"
            id="empresa"
            value={empresa}
            onChange={(e) => setEmpresa(e.target.value.toLowerCase())}
            placeholder="Empresa"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="email">E-mail:</Label>
          <Input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.toLowerCase())}
            placeholder="E-mail"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="password">Senha:</Label>
          <Input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Senha"
            required
          />
          <ForgotPassword onClick={handleForgotPassword}>
            Esqueceu a senha?
          </ForgotPassword>
        </FormGroup>
        <div>
          <SubmitButton type="submit">Entrar</SubmitButton>
        </div>
      </form>
    </LoginFormWrapper>
  );
};

export default LoginForm;
